import {Component, Element, h, Host, Prop} from '@stencil/core';

/**
 * @internal
 */
@Component({
    tag: 'joy-bottom-sheet-trigger',
    shadow: true,
})
export class JoyBottomSheetTrigger {
    @Element() host!: HTMLJoyBottomSheetTriggerElement;

    /** The ID of the dialog you want to show. Required **/
    @Prop({reflect: true}) bottomSheet!: string;

    private onClick = async () => {
        const bottomSheetToShow: HTMLJoyBottomSheetElement | null = this.host.ownerDocument.querySelector(`#${this.bottomSheet}`);
        if (!bottomSheetToShow) {
            return;
        }

        await bottomSheetToShow.openBottomSheet();
    };

    render() {
        return (
            <Host onClick={this.onClick}>
                <slot />
            </Host>
        );
    }
}
